<template>
  <div>
    <!-- Show maintenance view during downtime -->
    <div v-if="isUnderMaintenance" class="maintenance-container">
      <div class="maintenance-content">
        <i class="pi pi-exclamation-triangle maintenance-icon"></i>
        <h1 class="maintenance-title">System Maintenance</h1>
        <p class="maintenance-message">
          The system is currently under scheduled maintenance and will be back online shortly.
        </p>
        <div class="maintenance-schedule">
          <p><strong>Maintenance Period:</strong></p>
          <p>10 May 2026, 0:00 AM</p>
          <p>to</p>
          <p>10 May 2026, 11:59 PM</p>
        </div>
        <p class="maintenance-footer">We apologize for any inconvenience.</p>
      </div>
    </div>

    <!-- Show normal app when not under maintenance -->
    <div v-else>
      <router-view />

      <!-- Popup Image Modal -->
      <Dialog v-model:visible="showPopupModal" :closable="false" :modal="true" class="popup-modal" :showHeader="false"
        :contentStyle="{ padding: '0' }">
        <div class="popup-content">
          <Button icon="pi pi-times" class="p-button-rounded p-button-text close-btn" @click="showPopupModal = false" />
          <!-- <img src="img/LC_election-127.jpg" alt="Legislative Council Election 2025" class="popup-image"
            @click="openElectionSite" style="cursor: pointer;" /> -->
          <div class="downtime-notice">
            <div class="downtime-content">
              <i class="pi pi-exclamation-triangle downtime-icon"></i>
              <div class="downtime-message">
                <h3 class="downtime-title">System Maintenance</h3>
                <span class="downtime-text">
                  The system will be unavailable from
                  <strong>10 May 2026 0:00 AM</strong> to <strong>10 May 2026, 11:59 PM</strong> for scheduled
                  maintenance.
                </span>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  </div>
</template>

<script>

export default {
  name: 'App',
  data() {
    return {
      showPopupModal: new Date() < new Date('2026-05-10'),
      // showPopupModal: false,
    }
  },
  computed: {
    isUnderMaintenance() {
      // Get current time in Hong Kong timezone (UTC+8)
      const now = new Date();
      const hkTime = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Hong_Kong' }));
      const downtimeStart = new Date('2026-05-10T00:00:00');
      const downtimeEnd = new Date('2026-05-10T23:59:59');
      return hkTime >= downtimeStart && hkTime <= downtimeEnd;
      // return false;
    }
  },
  mounted() {
    // Redirect after maintenance period ends
    // const now = new Date();
    // const hkTime = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Hong_Kong' }));
    // const downtimeEnd = new Date('2026-02-09T09:00:00');
    // if (hkTime > downtimeEnd) {
    //   window.location.href = 'https://web-cnmp.epd.gov.hk/';
    // }
  },
  methods: {
    openElectionSite() {
      window.open('https://www.elections.gov.hk/legco2025/eng/index.html', '_blank');
    }
  }
}
</script>
<style>
html,
body {
  margin: 0;
  padding: 0;
  background-color: #2d3849;
}

#app {
  font-family: 'Times New Roman' !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #959da5;
}

.p-component {
  font-family: 'Times New Roman' !important;
}

.p-disabled {
  font-family: 'Times New Roman' !important;
}

.p-sr-only {
  font-family: 'Times New Roman' !important;
}

.p-reset {
  font-family: 'Times New Roman' !important;
}

.p-link {
  font-family: 'Times New Roman' !important;
}

.p-error {
  color: #b1120c !important;
  font-family: 'Times New Roman' !important;
}

.p-invalid {
  font-family: 'Times New Roman' !important;
}

.p-text-secondary {
  font-family: 'Times New Roman' !important;
}

.p-inputtext {
  font-family: 'Times New Roman' !important;
}

.popup-modal {
  width: 90vw;
  max-width: 800px;
}

.popup-modal :deep(.p-dialog) {
  margin: 0;
  background: transparent;
  box-shadow: none;
}

.popup-modal :deep(.p-dialog-content) {
  padding: 0;
  border-radius: 12px;
  overflow: hidden;
}

.popup-content {
  position: relative;
  width: 100%;
  background: transparent;
}

.close-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.6) !important;
  color: white !important;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid white;
}

.close-btn:hover {
  background: rgba(0, 0, 0, 0.8) !important;
}

.popup-image {
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.2s ease;
}

/* System Downtime Notice Styles */
.downtime-notice {
  width: 100%;
  background: linear-gradient(135deg, #ff6b6b 0%, #ff5252 100%);
  padding: 12px 16px;
  border-bottom: 3px solid #cc0000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  z-index: 900;
  position: relative;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.downtime-content {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 12px;
  color: white;
  font-weight: 500;
}

.downtime-message {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.downtime-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: white;
}

.downtime-icon {
  font-size: 20px;
  color: white;
  flex-shrink: 0;
  margin-top: 4px;
}

.downtime-text {
  font-size: 14px;
  line-height: 1.4;
}

/* Maintenance Container */
.maintenance-container {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #2d3849;
  font-family: 'Times New Roman', serif;
}

.maintenance-content {
  text-align: center;
  background: white;
  padding: 60px 40px;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 600px;
  animation: slideUp 0.6s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.maintenance-icon {
  font-size: 64px;
  color: #ff6b6b;
  display: block;
  margin-bottom: 20px;
}

.maintenance-title {
  font-size: 32px;
  font-weight: bold;
  color: #333;
  margin: 20px 0;
  font-family: 'Times New Roman' !important;
}

.maintenance-message {
  font-size: 18px;
  color: #666;
  margin-bottom: 30px;
  line-height: 1.6;
  font-family: 'Times New Roman' !important;
}

.maintenance-schedule {
  background: #f5f5f5;
  padding: 20px;
  border-radius: 8px;
  margin: 20px 0;
  font-family: 'Times New Roman' !important;
}

.maintenance-schedule p {
  margin: 8px 0;
  font-size: 16px;
  color: #555;
  font-family: 'Times New Roman' !important;
}

.maintenance-schedule strong {
  color: #333;
  font-size: 18px;
}

.maintenance-footer {
  font-size: 14px;
  color: #999;
  margin-top: 30px;
  font-style: italic;
  font-family: 'Times New Roman' !important;
}
</style>
